import { Container } from "@mui/material";
import AppBar from "../components/AppBar";
import { useSidebarLayout } from "../zustand/useSidebarStore";
import NavBar from "../components/NavBar";
import TablePromociones from "../components/tables/TablePromociones";

export default function PromotionsRoute() {
  const sidebar = useSidebarLayout();


  return (
    <>
      <AppBar />
      <Container maxWidth={false} sx={{ mt: 1, p: 1, ...sidebar }}>
        <NavBar />
        <TablePromociones />
      </Container>
    </>
  );
}
